export let SubmitResult = /*#__PURE__*/function (SubmitResult) {
  SubmitResult[SubmitResult["Success"] = 0] = "Success";
  SubmitResult[SubmitResult["Cancelled"] = 1] = "Cancelled";
  SubmitResult[SubmitResult["ValidationError"] = 2] = "ValidationError";
  SubmitResult[SubmitResult["SaveError"] = 3] = "SaveError";
  SubmitResult[SubmitResult["SubmitError"] = 4] = "SubmitError";
  SubmitResult[SubmitResult["UnknownError"] = 5] = "UnknownError";
  return SubmitResult;
}({});
export let ErrorType = /*#__PURE__*/function (ErrorType) {
  ErrorType[ErrorType["Validation"] = 0] = "Validation";
  ErrorType[ErrorType["Save"] = 1] = "Save";
  ErrorType[ErrorType["Submit"] = 2] = "Submit";
  return ErrorType;
}({});
export class SubmitError extends Error {
  constructor(type, error) {
    super(`submitError-${type}`);
    this.type = type;
    this.error = error;
  }
}